const normalizeStatus = (value) => String(value || '').trim().toLowerCase();

const hasZeroFlag = (value) => value !== null
  && value !== undefined
  && value !== ''
  && Number(value) === 0;

export const RESTRICTED_ACCOUNT_REASONS = Object.freeze(['banned', 'expired', 'disabled']);
export const RESTRICTED_ALLOWED_NAVIGATION_IDS = Object.freeze(['overview', 'credit', 'extend']);
export const RESTRICTED_ALLOWED_ROUTE_SECTIONS = Object.freeze(['overview']);
// Süresi dolan bayi alt kullanıcılarını yönetmeye devam eder; kendi yayın sayfaları kapalı kalır.
// 'setup' menüde yoktur: kurulum sayfası yalnızca bir alt kullanıcı için açılabilir.
export const EXPIRED_RESELLER_ALLOWED_NAVIGATION_IDS = Object.freeze([
  ...RESTRICTED_ALLOWED_NAVIGATION_IDS, 'user-actions', 'support',
]);
export const EXPIRED_RESELLER_ALLOWED_ROUTE_SECTIONS = Object.freeze([
  ...RESTRICTED_ALLOWED_ROUTE_SECTIONS, 'user-actions', 'support', 'setup',
]);
export const RESTRICTED_ACTION_MESSAGE = 'Hesabınız yeniden aktif olduğunda bu özellik kullanılabilir.';

export const isRestrictedAccountReason = (reason) => (
  RESTRICTED_ACCOUNT_REASONS.includes(String(reason || '').trim().toLowerCase())
);

export const getAccountAccessState = (userInfo, currentTime = Date.now()) => {
  const info = userInfo?.user_info || {};
  const accountUser = userInfo?.account_data?.user || {};
  const liveUser = userInfo?.user || {};
  const user = { ...info, ...accountUser, ...liveUser };
  const status = normalizeStatus(user.status ?? info.status);
  const expiryTimestamp = Number(user.exp_date);
  const hasValidExpiry = Number.isFinite(expiryTimestamp) && expiryTimestamp > 0;
  const isBanned = hasZeroFlag(user.admin_enabled) || status === 'banned';
  const isDisabled = hasZeroFlag(user.enabled) || ['disabled', 'inactive', 'passive'].includes(status);
  const isExpired = status === 'expired'
    || (hasValidExpiry && expiryTimestamp * 1000 <= currentTime);
  const reason = isBanned
    ? 'banned'
    : isDisabled
      ? 'disabled'
      : isExpired
        ? 'expired'
        : null;

  return {
    isActive: reason === null,
    isRestricted: reason !== null,
    isBanned,
    isDisabled,
    isExpired,
    reason,
    statusCode: isBanned ? 'Banned' : isDisabled ? 'Disabled' : isExpired ? 'Expired' : 'Active',
    statusLabel: isBanned ? 'Yasaklı' : isDisabled ? 'Kısıtlı' : isExpired ? 'Süresi Dolmuş' : 'Aktif',
    statusTone: isBanned ? 'banned' : isDisabled ? 'disabled' : isExpired ? 'expired' : 'active',
  };
};

/** Yalnızca süresi dolmuş bayi; yasaklı veya kapatılmış hesap bayi olsa da tamamen kısıtlıdır. */
export const hasExpiredResellerAccess = (access, isReseller) => (
  Boolean(isReseller) && access?.reason === 'expired'
);

export const canRestrictedAccountNavigate = (navigationId, expiredResellerAccess = false) => (
  (expiredResellerAccess ? EXPIRED_RESELLER_ALLOWED_NAVIGATION_IDS : RESTRICTED_ALLOWED_NAVIGATION_IDS)
    .includes(navigationId)
);

export const canRestrictedAccountOpenRoute = (sectionId, expiredResellerAccess = false) => (
  (expiredResellerAccess ? EXPIRED_RESELLER_ALLOWED_ROUTE_SECTIONS : RESTRICTED_ALLOWED_ROUTE_SECTIONS)
    .includes(sectionId)
);

export const canAccountUseSupheroChat = (isLoggedIn, userInfo, currentTime = Date.now()) => {
  if (!isLoggedIn) return true;

  const access = getAccountAccessState(userInfo, currentTime);
  return !access.isRestricted || access.reason === 'expired';
};
